'use strict';

var _ = require('lodash');
var fileUploaders = require('./fileUploaders');

var util = require('_core_ext/util');
var BaseCSSConstants = require('_core_ext/cssconstants');
var JSConstants = require('_core_ext/pages/tradecard/constants');
var CSSConstants = require('_core_ext/pages/tradecard/cssconstant');

var isFormValid = true;
var CONSTANT = {
    VALIDATE_DEBOUNCE: 200,
    SPECIAL_STEPS: []
};

function checkAddress($el) {
    return $el.length === 0 || $el.is(':visible');
}

function getCustomerRole () {
    return $(JSConstants.CUSTOMER_TYPE).val();
}

function isSuitableRole (role) {
    var currentRole = getCustomerRole();
    return currentRole === role;
}

function getFieldsToIgnore (customerRole) {
    var ignoreClass = ':hidden';
    // TODO: Memorize
    var isProfessional = customerRole === JSConstants.CONSTANTS.PROFESSIONAL;
    var isStudent = customerRole === JSConstants.CONSTANTS.STUDENT;
    var isBarber = customerRole === JSConstants.CONSTANTS.BARBER;

    var ignoreBarber = '.js-barber input, .js-barber select';
    var ignoreStudent = '.js-student input, .js-student select';
    var ignoreProfessional = '.js-professional input, .js-professional select';


    if (isProfessional) {
        ignoreClass = [ignoreBarber, ignoreStudent].join(', ');
    } else if (isBarber) {
        ignoreClass = [ignoreProfessional, ignoreStudent].join(', ');
    } else if (isStudent) {
        ignoreClass = [ignoreProfessional, ignoreBarber].join(', ');
    }
    return ignoreClass;
}

function scrollToFirstError(invalidElements) {
    if (invalidElements && invalidElements.length) {
        var elemetsArray = [];

        invalidElements.forEach(function (errorGroup) {
            errorGroup.element.each(function() {
                var $field = $(this);

                if ($field.is(':visible')) {
                    elemetsArray.push({
                        element: $field,
                        offset: +errorGroup.offset || 25
                    });
                }
                // Manual Touch of fields
                $field.blur();
            });
        });

        // eslint-disable-next-line no-inner-declarations
        function _filterFields (fieldsInfo) {
            return fieldsInfo.sort(function(info1, info2) {
                var $a = info1.element, $b = info2.element;
                var aOffset = $a.offset().top, bOffset = $b.offset().top;

                return aOffset - bOffset;
            });
        }

        elemetsArray = _filterFields(elemetsArray);
        var elementToScroll = elemetsArray[0];
        util.scrollBrowserTo(elementToScroll.element, 500, elementToScroll.offset);
    }
}

function checkFiles($fileInputs) {
    var valid = false,
        isBarber = isSuitableRole(JSConstants.CONSTANTS.BARBER),
        inActive = $fileInputs.parents(CSSConstants.STEPPER_INFO_DISABLED).length > 0 && isBarber;

    if ($fileInputs.length === 0 || inActive) {
        return true;
    }

    $fileInputs.each(function (index, el) {
        if (!valid && (el.files.length > 0)) {
            valid = fileUploaders.validateFiles(el.files);
        }
    });

    return valid;
}

function filterHiddenByParrent($fields) {
    return $fields.filter(function() {
        var $field = $(this);
        return $field.parents('.' + CSSConstants.HIDDEN).length > 0;
    });
}

function validateOptionalFields (fieldInfo, validator) {
    var $siretInput = fieldInfo.siretField,
        $kvkInput = fieldInfo.kvkField,
        $vatInput = fieldInfo.vatField,
        $enterpriseNumberInput = fieldInfo.enterpriseNumberField,
        $companyNameInput = fieldInfo.companyName;

    var _isContainError = function ($field) {
        return $field && $field.length > 0 && $field.val().length < 1;
    };

    var siretError = _isContainError($siretInput);
    var kvkError = _isContainError($kvkInput);
    var vatError = _isContainError($vatInput);
    var enterpriseNumberError = _isContainError($enterpriseNumberInput);
    var companyNameError = _isContainError($companyNameInput);

    if (!siretError && $siretInput.length > 0) {
        var siretValidation = validator.check($siretInput);
        siretError = !siretValidation;
    }

    if (!kvkError && $kvkInput.length > 0) {
        var kvkValidation = validator.check($kvkInput);
        kvkError = !kvkValidation;
    }

    if (!vatError && $vatInput.length > 0) {
        var vatValidation = validator.check($vatInput);
        vatError = !vatValidation;
    }

    if (!enterpriseNumberError && $enterpriseNumberInput.length > 0) {
        var enterpriseNumberValidation = validator.check($enterpriseNumberInput);
        enterpriseNumberError = !enterpriseNumberValidation;
    }

    if (siretError || kvkError || vatError || companyNameError || enterpriseNumberError) {
        return false;
    }
    return true;
}

function validateTradePhones ($phoneTradeFileds, validator) {
    var isValidPhones = true;

    $phoneTradeFileds.each(function () {
        if ($.trim(this.value).length && isValidPhones) {
            isValidPhones = validator.check(this);
        }
    });

    let filled = $phoneTradeFileds.filter(function() {
        return $.trim(this.value).length;
    });

    if (!filled.length || !isValidPhones) {
        return false;
    }
    return true;
}

function isFileValidation ($activeStep) {
    var isFileValidation = true,
        isProfessional = isSuitableRole(JSConstants.CONSTANTS.PROFESSIONAL),
        $companyOwner = $activeStep.find(JSConstants.CLASS_COMPANYOWNER_CHECK);

    if ($companyOwner && $companyOwner.length > 0 && isProfessional) {
        isFileValidation = !$companyOwner.prop('checked');
    }

    if ($(JSConstants.CLASS_REG_OPTION_SECTION + ':visible').attr('id') === 'create-company-account') {
        isFileValidation = false;
    }

    return isFileValidation;
}

/*
    Main validate function
    Do not update view only background checks
*/
function validateForm (event, $context, isPassive) {
    $context = $context || $(CSSConstants.STEPPER_STEP_ACIVE);

    if (!$context.length) {
        return;
    }

    var visibleModificator = isPassive ? '' : ':visible';
    var customerRole = getCustomerRole();
    var currentStep = parseInt($context.data('step'));

    isFormValid = false;
    var iterationResult = { valid: true, errorAreas: [] };
    var fieldsToIgnore = getFieldsToIgnore(customerRole);
    var validator = $context.validate();
    // Dynamic ignore change hack
    validator.settings.ignore = fieldsToIgnore;

    var $phoneTradeFileds = $context.find(JSConstants.CLASS_TRADE_PHONE);
    var $fieldsToOmitInitValidation = $phoneTradeFileds;
    var $allFieldsToValidate = $context.find('input' + visibleModificator + ', select.required' + visibleModificator);

    if (isPassive) {
        var $fieldsToOmit = $(fieldsToIgnore);
        var $birthday = $context.find(JSConstants.CLASS_BIRTHDAY);
        var $hiddenFields = filterHiddenByParrent($allFieldsToValidate);

        $fieldsToOmitInitValidation = $fieldsToOmitInitValidation
            .add($birthday).add($fieldsToOmit).add($hiddenFields);
    }
    // Validate checkboxes groups
    var $checkboxesGroup = $context.find(JSConstants.MANDATORY_CHECKBOXES_GROUP + visibleModificator);
    if (isPassive) {
        var $invalidCheckboxGroups = filterHiddenByParrent($checkboxesGroup);
        $checkboxesGroup = $checkboxesGroup.not($invalidCheckboxGroups);
    }

    $checkboxesGroup.each(function (index, group) {
        var $group = $(group);
        var $allCheckboxes = $group.find('input[type=checkbox]');
        var $checked = $group.find('input[type=checkbox]:checked');

        if ($checked.length === 0) {
            // Hack to trigger error message
            $allCheckboxes.addClass(CSSConstants.REQUIRED);

            iterationResult.valid = false;
            iterationResult.errorAreas.push({
                element: $group
            });
        } else {
            var $errors = $group.find('div.error');
            $errors.remove();
            $allCheckboxes.removeClass(CSSConstants.REQUIRED);
        }
    });
    // Validate trade phones (UK only)
    if ($phoneTradeFileds.length) {
        var tradePhonesValid = validateTradePhones($phoneTradeFileds, validator);

        if (!tradePhonesValid) {
            iterationResult.valid = false;
            iterationResult.errorAreas.push({
                element: $phoneTradeFileds
            });
        }
    }
    // Validate email
    var $emailError = $(JSConstants.EMAIL_ERROR);
    if (isPassive ? !$emailError.hasClass(CSSConstants.HIDDEN) : $emailError.is(visibleModificator)) {
        iterationResult.valid = false;
        iterationResult.errorAreas.push({
            element: $emailError, offset: 80
        });
    }

    // Validate Student Referral Store
    var $storeError = $(JSConstants.STORE_ERROR);

    if ($storeError && $storeError.length && (isPassive ? !$storeError.hasClass(CSSConstants.HIDDEN) : $storeError.is(visibleModificator))) {
        iterationResult.valid = false;
        iterationResult.errorAreas.push({
            element: $storeError, offset: 80
        });
    }

    // Validate mandatory checkboxes
    var $allCheckboxes = $context.find(JSConstants.MANDATORY_CHECKBOXES);
    var $checked = $allCheckboxes.filter(':checked');
    var isAllChecked = $checked.length === $allCheckboxes.length;

    if (!isAllChecked) {
        iterationResult.errorAreas.push({
            element: $allCheckboxes.not($checked)
        });
    }
    // Validate address
    var isAddressSelected = checkAddress($context.find(JSConstants.ADDRESS_RESULT));
    // Validate attached fileds
    var shouldValidateFiles = isFileValidation($context);
    var $fileUploaderInputs = $context.find(JSConstants.UPLOADER).find('input[name="files[]"]');
    var $fileCameraInputs = $context.find(JSConstants.CAMERA + visibleModificator).find('input[name="files[]"]');
    var $totalFilesInputs = $fileUploaderInputs.add($fileCameraInputs);
    var isFilesValid = shouldValidateFiles ? checkFiles($totalFilesInputs) : true;

    // Optional field validation
    var $siretInput = $context.find(JSConstants.CLASS_SIRET_NUMBER + visibleModificator),
        $kvkInput = $context.find(JSConstants.CLASS_KVK_NUMBER + visibleModificator),
        $vatInput = $context.find(JSConstants.CLASS_VAT_NUMBER + visibleModificator),
        $companyNameInput = $context.find(JSConstants.CLASS_COMPANY_NAME + visibleModificator),
        $enterpriseNumberInput = $context.find(JSConstants.CLASS_ENTERPRISE_NUMBER + visibleModificator);

    var isOptionalValid = shouldValidateFiles ? true : validateOptionalFields({
        siretField: $siretInput,
        kvkField: $kvkInput,
        vatField: $vatInput,
        companyName: $companyNameInput,
        enterpriseNumberField: $enterpriseNumberInput
    }, validator);

    if (shouldValidateFiles) {
        $fieldsToOmitInitValidation = $fieldsToOmitInitValidation
            .add($siretInput).add($kvkInput).add($vatInput).add($companyNameInput).add($enterpriseNumberInput);
    }

    var fieldsToValidate = $allFieldsToValidate.not($fieldsToOmitInitValidation);
    // Main validation by fields
    fieldsToValidate.each(function () {
        try {
            var $field = $(this);
            var checkResult = validator.check(this);

            if (!checkResult) {
                iterationResult.valid = false;
                iterationResult.errorAreas.push({
                    element: $field
                });
            }
        } catch (e) {
            console.error('Validate error: Field - ' + this.name, e);
        }
    });

    var isAdditionalValid = isAllChecked && isAddressSelected && isOptionalValid && isFilesValid;
    // Special Step - should have slightly different flow (active by default)
    var isSpecialStep = CONSTANT.SPECIAL_STEPS.indexOf(currentStep) > -1;
    // Change global variable
    isFormValid = (iterationResult.valid && isAdditionalValid);
    upgradeValidState(isFormValid, $context, isSpecialStep);

    return {
        valid: isFormValid,
        validator: validator,
        step: currentStep,
        isSpecial: isSpecialStep,
        context: $context,
        role: customerRole,
        fieldsInfo: iterationResult,
        additionalInfo: {
            isAllChecked: isAllChecked,
            isAddressSelected: isAddressSelected,
            isOptionalValid: isOptionalValid,
            isFilesValid: isFilesValid
        }
    };
}

/*
    Update step view based
    on validation status
*/
function upgradeValidState (isFormValid, $activeStep, isSpecial) {
    var customerRole = getCustomerRole();
    var currentStep = parseInt($activeStep.data('step'));

    var nextStep = isNaN(currentStep) ? null : currentStep + 1;
    var $nextStepTab = $(JSConstants.STEPPER_TAB + '[data-step=\'' + nextStep + '\']');
    var $nextButtons = $activeStep.find(JSConstants.NEXT_BT);
    $activeStep.find('button[type="submit"]').prop('disabled', !isFormValid);

     if (isSpecial) {
        var stepAttr = 'data-destination-step';
        $nextButtons.prop('disabled', false);
        $nextStepTab.prop('disabled', false);

        if (customerRole && isFormValid) {
            $nextButtons.attr(stepAttr, nextStep);
            $nextStepTab.attr(stepAttr, nextStep);
        } else {
            $nextButtons.removeAttr(stepAttr);
            $nextStepTab.removeAttr(stepAttr);
        }
    } else {
        $nextButtons.prop('disabled', !isFormValid);
        $nextStepTab.prop('disabled', !isFormValid);
    }
}

// Init regular events
function initValidationEvents () {
    var debouncedRegularValidation = _.debounce(function(e) {
        validateForm(e, null, false);
    }, CONSTANT.VALIDATE_DEBOUNCE);

    var debouncedSpecialValidation = _.debounce(function(e) {
        var validateResult = validateForm(e, null, false);

        if (validateResult.isSpecial) {
            scrollToFirstError(validateResult.fieldsInfo.errorAreas);
        }
    }, CONSTANT.VALIDATE_DEBOUNCE);

    if (CONSTANT.SPECIAL_STEPS.indexOf(1) > -1) {
        // To validate the page right after load
        debouncedRegularValidation();
    }

    $(document)
        .on('change', JSConstants.EMAIL, function() {
            $.ajax({
                type: 'POST',
                url: Urls.validateTradeCardEmail,
                data: {
                    'email': $(this).val()
                }
            }).done(function(response) {
                var $errorBlock = $(JSConstants.EMAIL_ERROR);
                var $emailField = $(JSConstants.EMAIL);
                var isSuccess = (response && response.success);

                if (isSuccess) {
                    $errorBlock
                        .html(response.message)
                        .removeClass(BaseCSSConstants.HIDDEN);
                } else {
                    $errorBlock.addClass(BaseCSSConstants.HIDDEN);
                }

                $emailField.trigger('focusout');
                $emailField.attr('aria-invalid', !isSuccess);
            });
        })
        .on('change focusout',
            'input:visible, select.required:visible, input:radio, input:checkbox, input:file,' +
            '.js-uploader-remove-file, .address__result, .uploader, .camera, [data-destination-role]', debouncedRegularValidation)
        .on('click', JSConstants.STEPPER_TAB + ', ' + JSConstants.NEXT_BT, debouncedSpecialValidation)
        .on('click', JSConstants.STEPPER_SHOW_OPTION, debouncedRegularValidation);
}

/*
    Collect steps of registration
    that has different validation flow
*/
function getSpecialSteps (isSpecial) {
    var stepsArray = [];
    var $specialSteps = $('[data-special-step="' + isSpecial + '"]');

    $specialSteps.each(function () {
        var $step = $(this);
        var specialStepNumber = parseInt($step.data('step'));

        if (!isNaN(specialStepNumber)) {
            stepsArray.push(specialStepNumber);
        }
    });
    return stepsArray;
}

module.exports = {
    init: function () {
        this.CONSTANT.SPECIAL_STEPS = getSpecialSteps(true);

        initValidationEvents();
    },
    validateForm: validateForm,
    scrollToFirstError: scrollToFirstError,
    CONSTANT: CONSTANT
};
